export default {
      id: "download-usage",
      viewBox: "0 0 30 30",
      url: "/assets/" + "icons.svg#download",
      toString: function () {
        return this.url;
      }
    }